import { h, Fragment } from 'preact';
import { useContext } from 'preact/compat';
import TextInput from '../inputs/TextInput';
import { Theme } from '../../lib/render';
import { useUser } from '../../hooks/user';

import CustomSelect from '../inputs/CustomSelect';
import * as states from '../../../static/state.json';
import * as countries from '../../../static/country.json';

/**
 * Format json obj to options array.
 */
const formatOptions = (json: any) => Object.keys(json).map((key) => ({
	value: key,
	label: json[key],
}));
const stateOptions = formatOptions(states);
const countryOptions = formatOptions(countries);

/**
 * Basic Address Component.
 * Goes under payment parent.
 */
const Address = () => {
	const {
		user, dispatch, dispatchTouch, touched, errors,
	} = useUser();

	const config = useContext(Theme);
	return (
		<Fragment>
			<div className="ea-address-label">
				<p>Billing Address</p>
			</div>
			<div className="ea-field-group">
				<CustomSelect
					label={config.form.Country.label}
					defaultValue={{
						value: 'US',
						label: 'United States',
					}}
					onTouch={() => {
						dispatchTouch({
							type: 'TOUCH_FIELD',
							payload: 'Country',
						});
					}}
					value={user.Country}
					options={countryOptions}
					onChange={(i) => {
						dispatch({
							type: 'UPDATE_USER',
							payload: {
								Country: i.value,
							},
						});
					}}
					hasError={(touched.includes('Country') && errors.Country) ? errors.Country : false}
				/>
			</div>
			<div className="ea-field-group ea-field-group-row">
				<TextInput
					name="AddressLine1"
					label={config.form.AddressLine1.label}
					placeholder={config.form.AddressLine1.placeholder}
				/>
				<TextInput
					name="AddressLine2"
					label={config.form.AddressLine2.label}
					placeholder={config.form.AddressLine2.placeholder}
				/>
			</div>
			<div className="ea-field-group">
				<TextInput
					name="City"
					label={config.form.City.label}
					placeholder={config.form.City.placeholder}
				/>
			</div>
			<div className="ea-field-group ea-field-group-row">
				{/**
					* Swap state for for state/province.
				  */
					user.Country === 'US' ? (
						<CustomSelect
							label={config.form.StateProvince.label}
							onTouch={() => {
								dispatchTouch({
									type: 'TOUCH_FIELD',
									payload: 'StateProvince',
								});
							}}
							value={user.StateProvince}
							options={stateOptions}
							onChange={(i) => {
								dispatch({
									type: 'UPDATE_USER',
									payload: {
										StateProvince: i.value,
									},
								});
							}}
							hasError={(touched.includes('StateProvince') && errors.StateProvince) ? errors.StateProvince : false}
							autoComplete="address-level1"
						/>
					) : (
						<TextInput
							name="StateProvince"
							label="State/Province"
							placeholder={config.form.StateProvince.placeholder}
						/>
					)
				}
				<TextInput
					name="PostalCode"
					label={config.form.PostalCode.label}
					placeholder={config.form.PostalCode.placeholder}
				/>
			</div>
		</Fragment>
	);
};

export default Address;
